/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Achievement_Night_Owl_HintInputs */

const en_us2_achievement_night_owl_hint = /** @type {(inputs: Achievement_Night_Owl_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 workouts after 10 pm`)
};

const pt_br2_achievement_night_owl_hint = /** @type {(inputs: Achievement_Night_Owl_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 treinos depois das 22h`)
};

const es_419_achievement_night_owl_hint = /** @type {(inputs: Achievement_Night_Owl_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 entrenamientos después de las 22 h`)
};

const pt_pt2_achievement_night_owl_hint = /** @type {(inputs: Achievement_Night_Owl_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 treinos depois das 22h`)
};

const fr_fr2_achievement_night_owl_hint = /** @type {(inputs: Achievement_Night_Owl_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 séances après 22 h`)
};

const de_de2_achievement_night_owl_hint = /** @type {(inputs: Achievement_Night_Owl_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 Trainings nach 22 Uhr`)
};

const it_it2_achievement_night_owl_hint = /** @type {(inputs: Achievement_Night_Owl_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 allenamenti dopo le 22`)
};

/**
* | output |
* | --- |
* | "3 workouts after 10 pm" |
*
* @param {Achievement_Night_Owl_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const achievement_night_owl_hint = /** @type {((inputs?: Achievement_Night_Owl_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Achievement_Night_Owl_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_achievement_night_owl_hint(inputs)
	if (locale === "es-419") return es_419_achievement_night_owl_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_achievement_night_owl_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_achievement_night_owl_hint(inputs)
	if (locale === "de-DE") return de_de2_achievement_night_owl_hint(inputs)
	if (locale === "it-IT") return it_it2_achievement_night_owl_hint(inputs)
	return en_us2_achievement_night_owl_hint(inputs)
});
export { achievement_night_owl_hint as "achievement.night_owl_hint" }